import React from 'react';

import { PM_DOCUMENTS_LIST, PP_DOCUMENTS_LIST, RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { TunnelBox, TunnelStep } from '../common';
import { SubmitButton } from 'components';
import { Typography } from '@mui/material';

const FCPRPedagogicalStep = props => {
    const { setSubmittedPedagogicalStep, fundName, roleChoice } = props;

    const renderDocument = (docName, index) => (
        <li key={index}>
            <Typography gutterBottom>{docName}</Typography>
        </li>
    );

    return (
        <TunnelStep
            title={
                <React.Fragment>
                    {texts.FCPR_PEDAGOGIC_STEP_TITLE}
                    <Typography style={{ fontSize: 'inherit' }}>{fundName}</Typography>
                </React.Fragment>
            }
            height="100%"
            overflow="auto"
            maxWidth={950}
        >
            <TunnelBox>
                <Typography gutterBottom>{texts.FCPR_PEDAGOGIC_STEP_PARAGRAPH_1}</Typography>
                <br></br>
                <Typography gutterBottom>{texts.FCPR_PEDAGOGIC_STEP_PARAGRAPH_2}</Typography>
                <ul>
                    {roleChoice === RoleNames.PM_PROFESSIONNEL
                        ? PM_DOCUMENTS_LIST.map(renderDocument)
                        : PP_DOCUMENTS_LIST.map(renderDocument)}
                </ul>
                <br></br>
                {roleChoice === RoleNames.PP_PROFESSIONNEL && (
                    <Typography gutterBottom>{texts.NIF_REQUIRED}</Typography>
                )}
                <Typography gutterBottom>
                    {roleChoice === RoleNames.PM_PROFESSIONNEL
                        ? texts.SOUSCRIPTION_PRENDRA_PM
                        : texts.SOUSCRIPTION_PRENDRA}
                </Typography>
                <Typography gutterBottom>
                    {roleChoice === RoleNames.PP_PROFESSIONNEL
                        ? texts.SIGNATURE_ELECTRONIQUE
                        : texts.SIGNATURE_NUMERIQUE}
                </Typography>
                <Typography gutterBottom>{texts.FCPR_PEDAGOGIC_STEP_PARAGRAPH_5}</Typography>
                <br></br>
            </TunnelBox>
            <SubmitButton onClick={() => setSubmittedPedagogicalStep(true)} text={texts.SUIVANT} />
        </TunnelStep>
    );
};

export default FCPRPedagogicalStep;
